import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { api_url } from "../globalFunction/global_string";

function SelectReport(props) {
  const [options, setOptions] = useState([]);
  const { id, name, requiredAPI, selectnet, selectunit, local_net_name, local_unit_name, parentName, selectedName, selectUrl, selectedDuration } = props;


  const loadData = () => {
    let apiUrl = api_url + requiredAPI;
    const formData = new FormData();
    if (parentName === 'superS') {
      formData.append("local_net_id", selectnet);
      formData.append("local_net_name", local_net_name);
      formData.append("local_unit_id", selectunit);
      formData.append("local_unit_name", local_unit_name)
      formData.append("timelimit", selectedDuration)
      formData.append("url_addr", selectUrl)

    } else if (parentName === 'superM') {
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
      formData.append("local_unit_id", selectunit);
      formData.append("local_unit_name", local_unit_name)
      formData.append("timelimit", selectedDuration)
      formData.append("url_addr", selectUrl)
    } else if (parentName === 'superN') {
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
      formData.append("local_unit_name", localStorage.getItem('login_local_unit_name'))
      formData.append("timelimit", selectedDuration)
      formData.append("url_addr", selectUrl)
    }

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        const rows = Array.isArray(data.row) ? data.row : [data.row];
        setOptions(rows);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  useEffect(() => {
    loadData();
  }, [selectnet, local_net_name, selectunit, local_unit_name, selectUrl, selectedDuration]);

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    //console.log(event.target)
    const selectedIndex = event.target.selectedIndex;
    const selectedName = event.target.options[selectedIndex].text;
    props.selectReport({ name, value, selectedName });
  };
  return (
    <Input
      id={id}
      name={name}
      onChange={handleSelectChange}
      type='select'
      value={selectedName}
    >
      <option key="0" value="">
        請選擇
      </option>
      {options.map(option => {
        // 格式化日期
        const originalFormat = option.build_date;
        const newFormat = originalFormat
          .replace(/\//g, "")
          .replace(/:/g, "")
          .replace(/ /g, "");

        // 組合最終顯示的字符串
        const displayText = `${newFormat}-${option.local_net_id}-${option.local_unit_id}-${option.serial_no}`;

        return (
          <option key={option.scan_id} value={option.scan_id}>
            {displayText}
          </option>
        );
      })}
    </Input>
  );
}

export default SelectReport;
